import { useQuery } from '@tanstack/react-query';
import { getAdminStats, getCategories } from '@/data/admin';

/**
 * Admin data hooks with aggressive caching
 * Prevents redundant queries on admin navigation
 */

export const useAdminStats = () => {
  return useQuery({
    queryKey: ['admin-stats'],
    queryFn: getAdminStats,
    staleTime: 5 * 60 * 1000,       // 5 min fresh
    gcTime: 30 * 60 * 1000,         // 30 min in memory
    refetchOnMount: false,           // Don't refetch if cached
    refetchOnWindowFocus: false,     // Don't refetch on tab focus
  });
};

export const useAdminCategories = () => {
  return useQuery({
    queryKey: ['admin-categories'],
    queryFn: getCategories,
    staleTime: 10 * 60 * 1000,      // 10 min (categories change rarely)
    gcTime: 60 * 60 * 1000,         // 1 hour
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
